<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js'
import { sendFandomAnalyticsEvent }  from 'src/modules/fandom_analytics_module.js'

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {
      submitInProgress: false,
      displayThanksMessage: false,
      answerSubmitted: false,
    };
  },
  mounted() {
    Vue.nextTick(() => {
      setTimeout(() => {
        this.mayOpenModal();
      }, this.getOpenDelay());
    });
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    applyContextToUrl: Fandom.applyContextToUrl,
    getOpenDelay: function() {
      return Fandom.exists(this.content.delay) ? this.content.delay : 3000;
    },
    mayOpenModal: function() {
      if(!Fandom.readCookie("pollModalCookie")) {
        sendFandomAnalyticsEvent("Interaction", "Popup Interaction View", this.content.name);
        $("#poll-modal").modal("show");
      }
    },
    closeModal: function() {
      if(!this.answerSubmitted) {
        sendFandomAnalyticsEvent("Interaction", "Popup Interaction Click", "Popup Interaction_PiùTardi");
      }
      $("#poll-modal").modal("hide");
    },
    sendPoll: function(pollAnswer) {
      this.submitInProgress = true;
      Fandom.ajax({
        methods: "post",
        url: "/api/v5/submit_poll",
        data: {
          content_id: this.content.id,
          upload_interaction_id: this.content.upload_interaction.interaction.id,
          poll_answer: pollAnswer
        },
        success: (data) => {
          Fandom.setCookie("pollModalCookie", true);
          this.submitInProgress = false;
          this.displayThanksMessage = true;
          const answer = data.answer == "true" ? "SI" : "NO";
          this.answerSubmitted = true;
          sendFandomAnalyticsEvent("Interaction", "Popup Interaction Click", `Popup Interaction_${answer}`);
          setTimeout(() => {
            this.closeModal();
          }, 1750)
        },
        error: (jqXHR,textStatus,errorThrown) => {
          this.submitInProgress = false;
          this.closeModal();
        },
      });
    }
  },

};
</script>

<template>
  <div class="modal fade" tabindex="-1"  id="poll-modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg mx-auto" role="document">
      <div class="modal-content poll-modal__body">
        <button type="button" class="close d-none d-sm-block" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="poll-modal__header">
          <p class="h6 text-center font-weight-normal">
            {{content.title}}
          </p>
          <p class="h6 text-center text-orange">
            {{content.subtitle}}
          </p>
          <div class="poll-modal__separator d-flex align-items-center justify-content-center my-5">
            <div class="poll-modal__separator__title px-3">
              <div class="poll-icon text-center">
                <svg class="w-100" xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">
                  <g fill="none" fill-rule="evenodd">
                    <circle cx="32.5" cy="32.5" r="32.5" fill="#B3B3B3"/>
                    <g stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M6.998 22s-.376-4.452 4.11-8.258C13.213 11.955 14 10.123 14 7.594 14 3.4 10.864 0 6.998 0 3.132 0 0 3.143 0 7.336M7.919 30c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1z" transform="translate(25 18)"/>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!displayThanksMessage">
          <div class="poll-modal__content px-3 text-center">
            <div v-for="elem in content.list" class="poll-modal__content-element d-flex align-items-center justify-content-center">
              <h4 v-html="elem.title" class="poll-modal__content-element__title mb-3"></h4>
              <p v-html="elem.text" class="poll-modal__content-element__text" v-if="elem.text"></p>
            </div>
          </div>
          <div class="py-4 row justify-content-center mx-0">
            <div class="col-6 col-md-5 col-lg-4 pr-2">
              <button type="button" @click="sendPoll(true)" class="btn btn-primary btn-block px-2 py-3" :disabled="submitInProgress">Si</button>
            </div>
            <div class="col-6 col-md-5 col-lg-4 pl-2">
              <button type="button" @click="sendPoll(false)" class="btn btn-primary btn-block px-2 py-3" :disabled="submitInProgress">No</button>
            </div>
          </div>
        </div>
        <div v-else class="text-center py-5">
          <div class="btn btn-green-apple btn-lg animated fadeIn slow" style="cursor: inherit;">Grazie per aver votato</div>  
        </div>
        <div class="py-3 text-center poll-modal__footer mt-4">
          <a href="javascript:void(0)" class="" @click="closeModal()">{{ft("globals.later")}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.poll-modal__separator__title {
  background-color: $white;
  display: inline-block;
  position: relative;
}

.poll-icon {
  width: 3.5rem;
}

.poll-modal__body {
  background-color: #fff;
  position: relative;
  a.btn {
    color: white !important;
  }
  a.poll-modal__close {
    position: absolute;
    top: .3rem;
    right: .5rem;
    color: black;
    font-size: 1.5rem;
  }
}

.poll-modal__header {
  padding-top: 2rem;
  font-family: $bressay-font;
}

.poll-modal__separator {
  height: 1px;
  background-color: $gray-500;
  margin: 2rem 0;
  position: relative;
  span {
    padding: 0 1rem;
    background-color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    font-family: $gotham-font;
    font-size: 0.75rem; /* 12/16 */
  }
}

.poll-modal__content-element {
  icon, svg {
    width: 60px;
    height: 60px;
  }

  p.poll-modal__content-element__title,
  p.poll-modal__content-element__title > p {
    font-family: $bressay-font;
    margin-bottom: 0;
  }
}

.poll-modal__footer {
  border-top: 1px solid $gray-500;
}
</style>